import Service from '../../service'

const state = {
    user: []
}
const actions = {
    onGetOther({ commit }, params = {}) {
        return Service.other.getOther(params).then(res => {
            // something
            return res.data
        })
    },
}
const mutations = {
    setPaymentList(state, data) {
        state.user = data
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}